<template>
  <div id="app">
    <div class="app-container">
      <!-- 顶部导航栏 -->
      <van-nav-bar title="公众互动平台" :fixed="true"></van-nav-bar>

      <!-- 主要内容区域 -->
      <div class="content-wrapper">
        <!-- 横幅区域 -->
        <div class="building-banner">
          <div class="banner-content">
<!--            <div class="banner-title">卫全物管</div>-->
<!--            <div class="banner-subtitle">智慧物业管理平台</div>-->
          </div>
        </div>

        <!-- 通知区域 -->
        <div v-if="false" class="section-card notice-section">
          <div class="section-header">
            <van-icon name="bell" class="section-icon" />
            <span class="section-title">重要通知</span>
          </div>
          <div class="notice-content" @click="showNoticeDetail(currentNoticeIndex)">
            <van-notice-bar
                v-if="notices.length > 0"
                :left-icon="notices[currentNoticeIndex]?.icon || 'volume-o'"
                :text="notices[currentNoticeIndex]?.topic || ''"
                background="#f8f9fa"
                color="#666"
            />
            <div v-else class="empty-notice">
              <van-icon name="info" class="empty-icon" />
              <span>暂无通知</span>
            </div>
          </div>
        </div>

        <!-- 功能图标区域 -->
        <div class="function-section">
          <div class="function-grid">
            <div
                v-for="item in functionItems"
                :key="item.id"
                class="function-item"
                @click="handleFunctionClick(item)"
            >
              <div class="function-icon" :style="{backgroundColor: item.color}">
                <van-icon :name="item.icon"/>
              </div>
              <div class="function-label">{{ item.text }}</div>
            </div>
          </div>
        </div>

        <!-- 公告区域 -->
        <div class="section-card announcement-section">
          <div class="section-header">
            <van-icon name="notes" class="section-icon" />
            <span class="section-title">小区公告</span>
          </div>
          <div class="announcement-list">
            <div
                v-for="(announcement, index) in announcements"
                :key="announcement.id"
                class="announcement-item"
                @click="showAnnouncementDetail(index)"
            >
              <div class="announcement-icon">
                <van-icon name="notes" />
              </div>
              <div class="announcement-content">
                <div class="announcement-title">{{ announcement.topic }}</div>
                <div class="announcement-date">{{ formatDate(announcement.start_time) }}</div>
              </div>
            </div>
            <div v-if="announcements.length === 0" class="empty-announcement">
              <van-icon name="info" class="empty-icon" />
              <p>暂无公告</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 通知详情弹窗 -->
      <van-popup v-model="showNoticePopup" round position="bottom" :style="{ height: '50%' }">
        <div class="popup-content">
          <div class="popup-header">
            <h3>通知详情</h3>
            <van-icon name="cross" @click="closePopup" />
          </div>
          <div class="popup-body">
            <div v-if="currentNoticeDetail" class="detail-content">
              <h4>{{ currentNoticeDetail.topic }}</h4>
              <div class="detail-meta">
                <span class="detail-date">{{ formatDate(currentNoticeDetail.date) }}</span>
                <span class="detail-type" :style="{backgroundColor: currentNoticeDetail.typeColor}">
                  {{ currentNoticeDetail.type }}
                </span>
              </div>
              <div class="detail-text">{{ currentNoticeDetail.content }}</div>
            </div>
          </div>
        </div>
      </van-popup>

      <!-- 公告详情弹窗 -->
      <van-popup v-model="showAnnouncementPopup" round position="bottom" :style="{ height: '60%' }">
        <div class="popup-content">
          <div class="popup-header">
            <h3>公告详情</h3>
            <van-icon name="cross" @click="closePopup" />
          </div>
          <div class="popup-body">
            <div v-if="currentAnnouncementDetail" class="detail-content">
              <h4>{{ currentAnnouncementDetail.topic }}</h4>
              <div class="detail-meta">
                <span class="detail-date">{{ formatDate(currentAnnouncementDetail.start_time) }}</span>
                <span class="detail-publisher">发布者: {{ currentAnnouncementDetail.userdep_names }}</span>
              </div>
              <div class="detail-text">{{ currentAnnouncementDetail.content }}</div>
            </div>
          </div>
        </div>
      </van-popup>

      <!-- 底部标签栏 -->
<!--      <van-tabbar v-model="activeTab" active-color="#1989fa">-->
<!--        <van-tabbar-item name="home" icon="home-o">首页</van-tabbar-item>-->
<!--        <van-tabbar-item name="mine" icon="user-o">我的</van-tabbar-item>-->
<!--      </van-tabbar>-->
    </div>
  </div>
</template>
<script>
import {getNotificationListByCondition} from "A/thjlcx";
import moment from "moment";

export default {
  name: 'home',
  data() {
    return {
      activeTab: 'home',
      // 通知相关数据
      notices: [
        {
          id: 1,
          topic: '小区电梯维护通知',
          content: '为保障电梯安全运行，将于6月25日对1号楼电梯进行例行维护，维护期间电梯将暂停使用，请业主提前安排出行。',
          date: '2023-06-22',
          type: '维护通知',
          typeColor: '#1989fa',
          icon: 'volume-o'
        },
        {
          id: 2,
          topic: '物业费缴纳提醒',
          content: '2023年第二季度物业费已开始收取，请各位业主于6月30日前缴纳，感谢您的配合。',
          date: '2023-06-15',
          type: '缴费提醒',
          typeColor: '#ff976a',
          icon: 'volume-o'
        },
        {
          id: 3,
          topic: '关于小区停水的通知',
          content: '由于市政供水管道维修，本小区将于2023年6月20日9:00-17:00停水，请各位业主提前做好储水准备。',
          date: '2023-06-18',
          type: '紧急通知',
          typeColor: '#ee0a24',
          icon: 'volume-o'
        }
      ],
      currentNoticeIndex: 0,
      showNoticePopup: false,
      currentNoticeDetail: null,
      // 公告相关数据
      announcements: [
        {
          id: 1,
          title: '夏季消防安全注意事项',
          content: '夏季高温，请注意用电用气安全，不私拉乱接电线，不在楼道堆放杂物，共同维护小区消防安全。如有发现安全隐患，请及时联系物业。',
          date: '2023-05-28',
          publisher: '物业服务中心'
        },
        {
          id: 2,
          title: '关于小区垃圾分类的倡议',
          content: '为响应市政府号召，提高小区环境质量，物业中心倡议全体业主积极参与垃圾分类，共同营造美好家园。具体分类标准请参考小区公告栏或物业公众号。感谢您的支持与配合！',
          date: '2023-06-10',
          publisher: '物业服务中心'
        },
        {
          id: 3,
          title: '小区儿童游乐设施更新完成',
          content: '小区儿童游乐区设施已全部更新完成，新增安全地垫和多种游乐设备，欢迎小朋友们前来玩耍。请家长注意看护，确保儿童安全。',
          date: '2023-06-05',
          publisher: '物业服务中心'
        },
        {
          id: 4,
          title: '小区绿化养护计划公告',
          content: '为美化小区环境，物业将于下周对小区绿化进行集中养护，期间部分区域可能会有临时围挡，敬请谅解。',
          date: '2023-06-12',
          publisher: '物业服务中心'
        }
      ],
      showAnnouncementPopup: false,
      currentAnnouncementDetail: null,
      // 功能图标数据
      functionItems: [
        { id: 1, text: '项目信息', icon: 'home-o', type: 'ProjectInfo' },
        { id: 2, text: '报事', icon: 'comment-o', type: 'ReportMatter' }, // 标记为报事类型
        { id: 3, text: '报修', icon: 'warn-o', type: 'ReportRepair' }, // 标记为报修类型
        { id: 5, text: '工单查询', icon: 'orders-o', type: 'Order' },
      ],
      // 定时器
      noticeTimer: null
    };
  },
  computed: {
  },
  mounted() {
    const paramValue = this.$route.query.param;
    this.$store.commit('setMonitorponintnum', paramValue);
    this.getNoticeList(paramValue)
    // 启动通知滚动
    // this.startNoticeScroll();
  },
  beforeDestroy() {
    // 清除定时器
    if (this.noticeTimer) clearInterval(this.noticeTimer);
  },
  watch: {
    // 监听弹窗关闭，恢复滚动
    showNoticePopup(val) {
      if (!val && this.notices.length > 1 && !this.noticeTimer) {
        this.startNoticeScroll();
      }
    }
  },
  methods: {
    getNoticeList(monitorpointnum){
      this.showLoading();
      let params={
        monitorpointnum:monitorpointnum,
        is_history: "0",
        is_invalid: "0",
        notice_type: "2",
        platform_type: "2",
        confirm_status:"1",
        whole:"0"
      }
      getNotificationListByCondition(params).then(res => {
        this.hideLoading();
        if(res&&res.returncode==='0'){
          this.announcements = res.item;
        }
      })
    },
    // 启动通知滚动
    startNoticeScroll() {
      if (this.notices.length > 1) {
        this.noticeTimer = setInterval(() => {
          this.currentNoticeIndex = (this.currentNoticeIndex + 1) % this.notices.length;
        }, 2000);
      }
    },
    // 显示通知详情
    showNoticeDetail(index) {
      if (this.notices.length > 0) {
        // 暂停滚动
        if (this.noticeTimer) {
          clearInterval(this.noticeTimer);
          this.noticeTimer = null;
        }

        this.currentNoticeDetail = this.notices[index];
        this.showNoticePopup = true;
      }
    },
    // 显示公告详情
    showAnnouncementDetail(index) {
      if (this.announcements.length > 0) {
        this.currentAnnouncementDetail = this.announcements[index];
        this.showAnnouncementPopup = true;
      }
    },
    // 关闭弹窗后恢复滚动
    closePopup() {
      this.showNoticePopup = false;
      this.showAnnouncementPopup = false;

      // 恢复通知滚动
      if (this.notices.length > 1 && !this.noticeTimer) {
        this.startNoticeScroll();
      }
    },
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '';
      // 将 "20241203090000" 按照 YYYYMMDDHHmmss 格式解析
      const parsedDate = moment(dateString, 'YYYYMMDDHHmmss')
      // 格式化为 "2024年12月3日"
      return parsedDate.format('YYYY年M月D日')
    },
    handleFunctionClick(item) {
      this.$router.push({ name: item.type });
    },
  }
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', sans-serif;
  background-color: #f5f6f9;
  color: #333;
  min-height: 100vh;
}

.app-container {
  /* 修改后：全宽自适应 */
  width: 100%;
  min-height: 100vh;
  background-color: #f5f6f9; /* 建议背景色设为浅灰，内容区设为白，更有层次感 */
  padding-bottom: 60px;
  /* 增加最大宽度限制，防止在超宽屏电脑上内容拉得太散（可选） */
  max-width: 600px;
  margin: 0 auto; /* 居中显示，但在手机上会占满 */
  box-shadow: 0 0 10px rgba(0,0,0,0.05); /* 在大屏幕上增加一点阴影，看起来像手机 */
}

.content-wrapper {
  margin-top: 46px;
  padding: 0 10px;
}

/* --- 顶部 Banner 优化 --- */
.building-banner {
  position: relative;
  width: 100%;
  height: 190px;
  background: linear-gradient(135deg, #1a73e8 0%, #4c9dff 100%);
  /* 这里可以替换为一张社区的模糊背景图，增加真实感 */
  background-image: url('~@/assets/image/shouye.png');
  background-size: cover;
  background-position: center;
  border-radius: 0 0 20px 20px;
  overflow: hidden;
  margin-bottom: 15px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(4px);
}

.banner-content {
  position: relative;
  z-index: 1;
  padding: 25px;
  text-align: center;
  color: white;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.banner-title {
  font-size: 26px;
  font-weight: 800;
  letter-spacing: 1px;
  margin-bottom: 6px;
}

.banner-subtitle {
  font-size: 13px;
  opacity: 0.9;
  font-weight: 400;
}

/* --- 通用卡片模块优化 --- */
.section-card {
  background: white;
  margin: 12px 0;
  padding: 16px;
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s, box-shadow 0.2s;
}

.section-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
  border-radius: 8px 8px 0 0;
}

.section-icon {
  font-size: 20px;
  margin-right: 10px;
  /* 使用品牌渐变色 */
  background: linear-gradient(45deg, #1a73e8, #3296fa);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.section-title {
  font-size: 17px;
  font-weight: 700;
  color: #1a1a1a;
}

.announcement-list{
  height: calc(5 * 76px); /* 5个项目高度，每个约76px */
  overflow-y: auto;
  max-height: 365px;
  padding-right: 8px;
}

/* --- 功能图标网格优化 --- */
.function-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-top: 4px;
}

.function-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 8px;
  border-radius: 12px;
  background-color: #f9fafd;
  transition: all 0.2s ease;
  cursor: pointer;
}

.function-item:hover {
  background-color: #edf2ff;
  transform: scale(1.05);
}

.function-icon {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  font-size: 26px;
  color: white;
  /* 为不同功能设置不同的渐变色，提升视觉引导 */
  background: linear-gradient(135deg, #1a73e8 0%, #4c9dff 100%);
  box-shadow: 0 4px 10px rgba(26, 115, 232, 0.3);
}

/* 报事/报修重点突出 */
.function-item:nth-child(2) .function-icon,
.function-item:nth-child(3) .function-icon {
  background: linear-gradient(135deg, #ff9a00 0%, #ff6b35 100%);
  box-shadow: 0 4px 10px rgba(255, 107, 53, 0.3);
}

.function-label {
  font-size: 13px;
  color: #555;
  font-weight: 500;
}

/* --- 通知与公告列表优化 --- */
.notice-content,
.announcement-item {
  padding: 12px 15px;
  border-radius: 10px;
  margin-bottom: 8px;
  background-color: #f8f9fa;
  border-left: 3px solid #1a73e8;
  transition: background-color 0.2s;
}

.notice-content:hover,
.announcement-item:hover {
  background-color: #eef3ff;
  border-left-color: #3296fa;
}

.announcement-item {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eee;
}

.announcement-icon {
  background-color: #e3f2fd;
  color: #1a73e8;
}

.announcement-content {
  flex: 1;
  overflow: hidden;
}

.announcement-title {
  font-size: 14px;
  color: #333;
  font-weight: 600;
  margin-left: 10px;
}

.announcement-date {
  font-size: 11px;
  color: #999;
  margin-left: 10px;
}

/* --- 弹窗优化 --- */
.popup-content {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.popup-header {
  padding: 16px 16px 12px;
  border-bottom: 1px solid #eee;
  background-color: #f8f9fa;
}

.popup-header h3 {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
}

.popup-body {
  flex: 1;
  padding: 16px;
  overflow-y: auto;
  line-height: 1.8;
  color: #555;
}

.detail-meta {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  font-size: 12px;
  color: #666;
}

.detail-type {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
}
</style>